const tooltipTrigger = document.getElementById('tooltip-trigger');

if (tooltipTrigger) {
    tooltipTrigger.addEventListener('click', () => {
        const text = document.getElementById('tooltip-content');

        text.classList.toggle('hidden');
    });
}
const buttons = document.querySelectorAll('.get-in-touch-btn');

const setFieldValue = (fieldName, value) => {
    const fields = document.querySelectorAll(`[name="${fieldName}"]`);

    fields.forEach((field) => {
        if (field.type === 'radio' || field.type === 'checkbox') {
            field.checked = field.value === value;

            field.dispatchEvent(new Event('input', {bubbles: true}));
            field.dispatchEvent(new Event('change', {bubbles: true}));

            return;
        }

        field.value = value;

        field.dispatchEvent(new Event('input', {bubbles: true}));
        field.dispatchEvent(new Event('change', {bubbles: true}));
    });
};

buttons.forEach((button) => {
    button.addEventListener('click', function () {
        const formLabel = button.getAttribute('data-form-label');

        setFieldValue('fields[whatAreYouLookingFor][]', formLabel);

        const form = document.getElementById('embedded-form');

        if (form) {
            form.scrollIntoView({behavior: 'smooth'});
        }
    });
});
